import { action, computed, thunk } from "easy-peasy";
import DashboardModel from "Store/models/dashboard";

var _groupBy = require("lodash/groupBy");

export const ACTION_TYPES = {
  FAILED: 1,
  FINISHED: 2,
  FETCHING_DATA: 5,
  FETCHED_DATA: 6,
};

const TotalRentableAreasDashboardModel = {
  chartData: computed((state) => {
    let _chartData = [];

    var data = _groupBy(state.data, function (item) {
      return `${item.unitCode}/${item.subUnitCode}`;
    });

    for (const [key, value] of Object.entries(data)) {
      var item = { "Birim/Alt Birim": key };
      value.forEach((f) => {
        item[f.position === "EMPTY" ? "Boş" : "Dolu"] = f.totalCount;
      });

      _chartData.push(item);
    }

    return _chartData;
  }),
  ...DashboardModel("totalrentableareas"),
};

export default TotalRentableAreasDashboardModel;
